import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { Reservation } from '../../classes/reservation';

@Component({
  selector: 'app-success-reservation',
  templateUrl: './success-reservation.component.html',
  styleUrls: ['./success-reservation.component.scss']
})
export class SuccessReservationComponent implements OnInit, AfterViewInit{

  @Input()
  reservation: Reservation;

  constructor() { }

  ngOnInit(): void {	
  }

  ngAfterViewInit() {
    
  }

}
